function Canvas(type, identifier, uuid, width, height, logger, pixelated = false) {
  const element = document.createElement('canvas');
  const context = element.getContext(type);
  const ratio = window.devicePixelRatio || 1;

  function focus() {
    element.setAttribute('tabindex', 0);
    element.focus();
  }

  function resize(width, height) {
    this.ratio = window.devicePixelRatio || 1;

    // if (pixelated === true) {
    //   ratio = Math.floor(ratio);
    // }

    element.setAttribute('width', this.ratio * width);
    element.setAttribute('height', this.ratio * height);

    element.style.width = `${width}+px`;
    element.style.height = `${height}+px`;

    //  element.style['aspect-ratio'] = `auto ${width} / ${height}`;
    /* if (context.scale) {
      context.scale(this.ratio, this.ratio);
    } */

    if (context) {
      context.setTransform(this.ratio, 0, 0, this.ratio, 0, 0);
    }

    if (pixelated === true) {
      sharp();
    }
  }

  function sharp() {
    element.style.imageRendering = '-moz-crisp-edges';
    element.style.imageRendering = '-webkit-crisp-edges';
    element.style.imageRendering = 'crisp-edges';
    element.style.imageRendering = 'pixelated';
    context.imageSmoothingEnabled = false;
  }

  element.setAttribute('id', `${identifier}_${uuid}`);
  element.addEventListener('mousedown', focus);

  this.resize = resize.bind(this);
  this.resize(width, height);

  this.logger = logger;
  this.context = context;
  this.element = element;
  this.focus = focus;
  this.ratio = ratio;
}

// exports current module as an object
export { Canvas };
